export const ECRAN_AJOUT_FACES = {
  title: 'Ajouter une face unitaire',
  breadcrumb: {
    title: 'Ajouter une face unitaire',
  },
  actions: {
    back: 'Retour',
  },
  buttons: {
    selection: 'Sélection',
    search: 'Ma recherche',
  },
  periode: 'Du {dateDebut} au {dateFin}',
  dateFrom: 'A partir du {dateDebut}',
  table: {
    reference: 'Référence',
    format: 'Format',
    materiel: 'Matériel',
    address: 'Adresse',
    zipCode: 'CP',
    city: 'Ville',
    affectation: 'Affectations',
  },
  rechercheContent: {
    au: 'au',
    recherche: 'Ma recherche',
    appliquerRecherche: 'Appliquer les paramètres de votre recherche',
    periode: 'Période',
    references: 'Référence(s)',
    villes: 'Ville',
    departements: 'Département',
    materiels: 'Matériel',
    formats: 'Format',
    appliquer: 'Appliquer',
    reinitialiser: 'Réinitialiser',
    errors: {
      datesRequired: 'La date de début est obligatoire',
      dateDebutGreaterDateFin: 'La date de début est plus grande que la date de fin',
      problemOccurred: 'Un problème est survenu',
    },
  },
};

export const LISTE_PRODUIT_FACE = {
  title: 'Liste des produits faces unitaires',
  titleSuiviAffectations: 'Suivi d\'affectations des produits faces unitaires',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des produits faces unitaires',
    listeSuiviAffectations: 'Suivi d\'affectations des produits faces unitaires',
  },
  actions: {
    search: 'Rechercher',
    filtre: 'Filtre',
    add: 'Nouveau produit face unitaire',
    edit: 'Modifier',
    archiver: 'Archiver',
    desarchiver: 'Désarchiver',
    delete: 'Supprimer',
    edition: 'Générer édition',
  },
  tabs: {
    reference: 'Référence',
    adresse: 'Adresse',
    codePostal: 'CP',
    ville: 'Ville',
    departement: 'Dpt.',
    format: 'Format',
    materiel: 'Matériel',
    support: 'Support',
    affectation: 'Affectation com.',
    societe: 'Société',
    agence: 'Agence',
    regroupementProduit: 'Regr.',
    actif: 'Archivé',
    disposition: 'Disposition',
    etat: 'Etat',
  },
  infoAffectation: {
    title: 'Affectation(s) de la face unitaire {code}',
    noAffectation: 'Aucune affectation pour cette face unitaire',
    multiAffectation: 'Multi-affectation',
    commande: ' jusqu\'au {date}',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    dateReferenceAffectation: 'Date référence affectation',
    dateConsultation: 'Date pivot',
    reference: 'Référence(s)',
    regroupementProduit: 'Regroupement de produit(s)',
    actif: 'Actif',
    yes: 'Oui',
    no: 'Non',
    ville: 'Ville(s)',
    departement: 'Département(s)',
    format: 'Format(s)',
    materiel: 'Matériel(s)',
    support: 'Support(s)',
    agglomeration: 'Agglomération(s)',
    angleVision: 'Angle(s) de vision',
    codePostal: 'Code postal',
    localisation: 'Localisation(s)',
    agence: 'Agence',
    adresses: 'Adresse(s)',
    proposableLc: 'Proposable en LC',
    proposableReseau: 'Proposable en réseau',
    societe: 'Société',
    nonCommercialisable: 'Non commercialisable',
    eclaire: 'Eclairé',
    avecLiaisonsTarif: 'Avec produits associés',
    avecCoordonnees: 'Avec Coordonnees GPS',
    controleDisponibilite: 'Controle disponibilité',
    affectation: {
      title: 'Affectation',
      libelle: 'Libellé de l\'affectation',
      aucune: 'Aucune',
      reseau: 'Réseau',
      commande: 'Longue conservation',
      multiple: 'Multiple',
    },
    secteurs: 'Secteurs(s)',
    hasSecteur: 'Présent dans un secteur',
    exclureVilles: 'Exclure ville(s)',
    errors: {
      dateReferenceAffectation: 'La date de référence d\'affectation est obligatoire',
      datePivotAffectation: 'La date pivot d\'affectation est obligatoire',
    },
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  archivage: {
    archiver: 'Etes-vous sûr de vouloir archiver ce produit ?',
    desarchiver: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    sucessArchivage: 'Produit archivé avec succès',
    successDesarchivage: 'Produit désarchivé avec succès',
  },
};
